import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { SidebarNavLink, NavbarBrand, Heading, Navbar } from 'legion-ui';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const NavbarToggle = makeShortcode("NavbarToggle");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`A spinner component to display a loading state of a page or section.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { SidebarNavLink } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`Legion have 2 variant of sidebar`}</p>
    <h3><strong parentName="h3">{`Basic`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <Navbar variant="fixed" style={{
        "borderBottom": "1px solid #ddd"
      }} mdxType="Navbar">
    <NavbarBrand mdxType="NavbarBrand">
      <Heading size="h3" color="primary500" mdxType="Heading">
        Legion
      </Heading>
      <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} mdxType="NavbarToggle" />
    </NavbarBrand>
  </Navbar>
  <SidebarNavLink style={{
        "background": "white"
      }} listItems={[{
        icon: 'Home',
        route: '',
        title: 'Home'
      }, {
        icon: 'BookOpen',
        route: '',
        title: 'Library'
      }, {
        icon: 'Settings',
        route: '',
        title: 'Setting'
      }]} mdxType="SidebarNavLink"></SidebarNavLink>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    <Navbar variant="fixed" mode="dark" isBordered>
        <NavbarBrand>
            <Heading size="h3" color="primary500">
            Legion
            </Heading>
            <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
        </NavbarBrand>
    </Navbar>
     <SidebarNavLink listItems={[
        { icon: 'Home', route: '#', title: 'Home' },
        { icon: 'BookOpen', route: '#', title: 'Library' },
        { icon: 'Settings', route: '#', title: 'Setting' }
    ]}>
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`With Sub Menu`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <Navbar variant="fixed" style={{
        "borderBottom": "1px solid #ddd"
      }} mdxType="Navbar">
    <NavbarBrand style={{
          display: 'flex',
          alignItem: 'center'
        }} mdxType="NavbarBrand">
      <Heading size="h3" color="primary500" mdxType="Heading">
        Legion
      </Heading>
      <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} mdxType="NavbarToggle" />
    </NavbarBrand>
  </Navbar>
  <SidebarNavLink style={{
        "background": "white"
      }} listItems={[{
        icon: 'Home',
        route: '',
        title: 'Home'
      }, {
        icon: 'HelpCircle',
        route: '',
        title: 'About us',
        isParent: true,
        submenuItems: [{
          icon: 'Coffee',
          route: '',
          title: 'sub profile 1'
        }, {
          icon: 'Box',
          route: '',
          title: 'sub profile 2'
        }]
      }, {
        icon: 'BookOpen',
        route: '',
        title: 'Library'
      }, {
        icon: 'Settings',
        route: '',
        title: 'Setting'
      }]} mdxType="SidebarNavLink"></SidebarNavLink>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    <Navbar variant="fixed" mode="dark">
        <NavbarBrand style={{display: 'flex', alignItem: 'center'}}>
            <Heading size="h3" color="primary500">
            Legion
            </Heading>
            <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
        </NavbarBrand>
    </Navbar>
     <SidebarNavLink listItems={[
        { icon: 'Home', route: '#', title: 'Home' },
        { icon: 'HelpCircle', route: '#', title: 'About us', isParent: true, submenuItems:
            [
                { icon: 'Coffee', route: '#', title: 'sub profile 1' },
                { icon: 'Box', route: '#', title: 'sub profile 2' }
            ]
        },
        { icon: 'BookOpen', route: '#', title: 'Library' },
        { icon: 'Settings', route: '#', title: 'Setting' }
    ]}>
    </SidebarNavLink>
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <h3><strong parentName="h3">{`Sidebar NavLink`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode `}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the necessary components here as a header slot`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`listItems`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Array of Object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the menu list as array of object with the following listItems`}{`[key]`}{`:`}</td>
        </tr>
      </tbody>
    </table>
    <div className="divi" />
    <h3><strong parentName="h3">{`List Item`}</strong></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`route`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets menu icon`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`icon`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`IconName from `}<a parentName="td" {...{
              "href": "https://feathericons.com"
            }}>{`react-feather`}</a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets menu link`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`title`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets menu title`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isParent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets menu as parent menu`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`submenuItems`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Array of Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets submenu items when isParent is true, fill submenuItems with Array of Object contains icon, route, and title.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      